import "./TransporterMove.scss";

import config from "../../../config";

import React from "react";
import { inject, observer } from "mobx-react";
import { RouteNode } from "react-router5";

import Frame from "../Frame/Frame";
import PagerAmount from "../../Components/Pager/PagerAmount";
import Pager from "../../Components/Pager/Pager";
import Popup from "../../Components/Popup/Popup";
import RefreshButton from "../../Components/RefreshButton/RefreshButton";
import { STORE_CONFIG } from "../../Store/ConfigStore";
import {
  ROUTE_TRANSPORTER_MOVE,
  ROUTE_TRANSPORTER_MOVE_DETAILS,
} from "../../routes";
import {
  STORE_TRANSPORTER_MOVE,
  SORT_ASC,
  SORT_DESC,
} from "../../Store/TransporterMoveStore";
import { STORE_AUTH } from "../../Store/AuthStore";
import axios from "axios";
import DatePicker, { registerLocale } from "react-datepicker";
import hu from "date-fns/locale/hu";
registerLocale("hu", hu);
import { formatDate, formatDateOnly } from "../../utility";
import { timeout } from "q";
import XLSX from "xlsx";

import Select from "react-select";
import { SelectStyle, DropdownIndicator } from "../App/select_style";
import Button from "../../Components/Button/Button";

const SORT_TRANSPORTER = "Transporter";
const SORT_USER = "User";
const SORT_CLEANINGRATE = "CleaningRateName";
const SORT_LOTNO = "LotNo";
const SORT_ITEM = "ItemName";
const SORT_AMOUNT = "Quantity";
const SORT_BIN = "BinCode";
const SORT_AUTOBIN = "AutoBinCode";
const SORT_TIMESTAMP = "TimeStamp";
const SORT_TYPE = "TypeName";

function Sorter(props) {
  const asc = ["sorter__dir sorter__dir-asc"];
  const desc = ["sorter__dir sorter__dir-desc"];
  if (props.activeDirection === SORT_ASC) {
    asc.push("sorter__dir--active");
  } else if (props.activeDirection === SORT_DESC) {
    desc.push("sorter__dir--active");
  }
  return (
    <div
      className={"sorter" + (props.activeDirection ? " sorter--active" : "")}
    >
      <div className={asc.join(" ")} title="rendezés növekvő sorrendbe" />
      <div className={desc.join(" ")} title="rendezés csökkenő sorrendbe" />
    </div>
  );
}

const TableSearch = inject((stores) => ({
  store: stores.store.get(STORE_TRANSPORTER_MOVE),
}))(
  observer((props) => {
    const { store } = props;
    const cancelClassname =
      "search-cancel-button" + (store.searchtext.length > 0 ? "" : " hidden");
    return (
      <div className="table-search">
        <div className="table-search__label">Keresés</div>
        {/*<div className="table-search__input-container">      
        <input className="form-input form-input--inline" type="text" name="focus" value={store.search} onChange={e => store.setSearch(e.target.value)} />       
    </div>*/}
        <div className="search-wrapper">
          <input
            className="search-input"
            value={store.searchtext}
            onChange={(e) => store.setSearchText(e.target.value)}
          />
          <div
            className={cancelClassname}
            onClick={(e) => {
              store.setSearchText("");
              store.setSearch();
            }}
          >
            <i className="fas fa-times"></i>
          </div>
        </div>
        <div
          className="btn searchbutton"
          onClick={(e) => {
            store.setSearch(store.searchtext);
          }}
        >
          Keres
        </div>
      </div>
    );
  })
);

@inject((stores) => ({
  store: stores.store.get(STORE_TRANSPORTER_MOVE),
  configStore: stores.store.get(STORE_CONFIG),
  authStore: stores.store.get(STORE_AUTH),
  socket: stores.socket,
  router: stores.router,
}))
@observer
class Table extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      popup: "none",
      popupText: "",
      showTerminated: false,
      from: null,
      to: null,
      subtable: null,
    };

    this.refresh();
  }

  onClickSort = (field) => () => {
    const { store } = this.props;
    if (store.sortField === field) {
      store.flipSortDirection();
    } else {
      store.setSortField(field);
      store.setSortDirection(SORT_ASC);
    }
  };

  typedValue = (value) => {
    return {
      t: isNaN(value) ? "s" : "n",
      v: value,
    };
  };

  refresh() {
    const { store, socket } = this.props;

    const data = {
      From: store.from ? store.fromFormatted : null,
      To: store.to ? store.toFormatted : null,
    };

    const _this = this;
    socket.emitWithToken("GetTransporterMove", data, function (err, data) {
      if (err) {
        console.error(err);
        return;
      }
      store.setItems(data);
      _this.setState({ newContentAvailable: false });
    });
  }

  showPopup = (text) => {
    this.setState({ popup: "show", popupText: text });
  };

  render() {
    const { store, configStore, authStore, route, router, socket } = this.props;
    const { shownItems, sortDirection, sortField, pager, uploading } = store;
    const { itemCount, lastShownItem, firstShownItem } = pager;
    let { name: routeName, params: routeParams } = route;
    const { showTerminated } = this.state;

    let rows = [];
    shownItems.forEach((pallet) => {
      store.palletHistory &&
        store.palletHistory.PalletId === pallet.Id &&
        console.log(configStore.machines);

      rows.push(
        <tr key={pallet.Id}>
          <td>{pallet.TimeStamp}</td>
          <td>{pallet.TypeName}</td>
          <td>{pallet.Transporter}</td>
          <td>{pallet.UserName}</td>
          <td className="table-cell-active">
            <span>{pallet.LotNo}</span>
            {pallet.SealNum ? <br /> : null}{" "}
            {pallet.SealNum ? "(" + pallet.SealNum + ")" : ""}
          </td>
          <td>{pallet.CleaningRateName}</td>
          <td>{pallet.ItemName}</td>
          <td>
            {(pallet.BagType === 2
              ? pallet.BagCount + " x " + pallet.Quantity
              : pallet.Quantity) + " kg"}
          </td>
          <td>{pallet.BinCode}</td>
          <td>{pallet.AutoBinCode}</td>
        </tr>
      );
    });

    return (
      <Frame>
        <div className="table basic-content">
          <div className="table__top">
            <div className="table-pager-amount">
              <PagerAmount
                perPage={pager.perPage}
                onChange={(e) => pager.setPerPage(e.value)}
              />
            </div>
            <div className="table-datepicker-block">
              Létrehozva&nbsp;
              <DatePicker
                className="table input-date form-input"
                dateFormat="yyyy-MM-dd"
                selected={store.from}
                onChange={(date) => {
                  store.setFrom(date);
                  this.refresh();
                }} /*locale='hu'*/
              />
              <div className="separator"></div>
              <DatePicker
                className="table input-date form-input"
                dateFormat="yyyy-MM-dd"
                selected={store.to}
                onChange={(date) => {
                  store.setTo(date);
                  this.refresh();
                }} /*locale='hu'*/
              />
            </div>
            <TableSearch />
            <RefreshButton
              onClick={() => {
                this.refresh();
              }}
              newContentAvailable={this.state.newContentAvailable}
            />
          </div>
          <div className="table__content">
            <table>
              <thead>
                <tr>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_TIMESTAMP)}
                    >
                      Időbélyeg
                      <Sorter
                        activeDirection={
                          sortField === SORT_TIMESTAMP ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_TYPE)}
                    >
                      Típus
                      <Sorter
                        activeDirection={
                          sortField === SORT_TYPE ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_TRANSPORTER)}
                    >
                      Targonca
                      <Sorter
                        activeDirection={
                          sortField === SORT_TRANSPORTER ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_USER)}
                    >
                      Felhasználó
                      <Sorter
                        activeDirection={
                          sortField === SORT_USER ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_LOTNO)}
                    >
                      Raklap azonosító
                      <Sorter
                        activeDirection={
                          sortField === SORT_LOTNO ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_CLEANINGRATE)}
                    >
                      Fok
                      <Sorter
                        activeDirection={
                          sortField === SORT_CLEANINGRATE ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_ITEM)}
                    >
                      Cikk
                      <Sorter
                        activeDirection={
                          sortField === SORT_ITEM ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_AMOUNT)}
                    >
                      Mennyiség
                      <Sorter
                        activeDirection={
                          sortField === SORT_AMOUNT ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_BIN)}
                    >
                      Hely (könyvelt)
                      <Sorter
                        activeDirection={
                          sortField === SORT_BIN ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_AUTOBIN)}
                    >
                      Hely (automata)
                      <Sorter
                        activeDirection={
                          sortField === SORT_AUTOBIN ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody className="table_body">{rows}</tbody>
            </table>
          </div>
          <div className="table__bottom">
            <div>
              {firstShownItem} - {lastShownItem} találat mutatása {itemCount}{" "}
              közül
            </div>
            <Pager
              routeName={routeName}
              routeParams={routeParams}
              pager={pager}
              onClickPage={(page) => pager.setCurrentPage(page)}
            />
          </div>
        </div>
        {this.state.popup === "none" ? null : (
          <Popup
            key="popup"
            text={this.state.popupText}
            onClickClose={() => this.setState({ popup: "none" })}
          />
        )}
      </Frame>
    );
  }
}

export {
  SORT_ASC,
  SORT_DESC,
  SORT_CLEANINGRATE,
  SORT_LOTNO,
  SORT_AMOUNT,
  SORT_TIMESTAMP,
  SORT_TYPE,
  SORT_BIN,
  SORT_AUTOBIN,
  SORT_ITEM,
  SORT_USER,
  SORT_TRANSPORTER,
};

export default (props) => (
  <RouteNode nodeName={ROUTE_TRANSPORTER_MOVE}>
    {(routeProps) => <Table {...routeProps} {...props} />}
  </RouteNode>
);
